import React from 'react'
import RepricerSection from './RepricerSection'
import SearchMonitoringSection from './SearchMonitoringSection'
import MonitoringSection from './MonitoringSection'
import { PrimaryButton } from '../../components'

const ServiceCard = ({ icon, title, description, color, buttonLink }) => (
  <div className="bg-[#1A1D21] rounded-[20px] lg:rounded-[60px] relative">
    <div className="absolute inset-0 overflow-hidden rounded-[20px] lg:rounded-[60px] z-0">
      <div className="absolute top-0 right-0 w-[200px] h-[200px]">
        <div
          className={`absolute inset-0 rounded-full  -translate-y-3/4  ${color} opacity-60 blur-[80px] w-[140%] h-[140%] `}
        ></div>
      </div>
    </div>

    <div className="p-10 relative z-10 mb-20">
      <h3 className="text-[#FBFBFC] text-xl font-medium mb-2 mt-10">{title}</h3>
      <p className="text-[#9DA3AE] text-base">{description}</p>
    </div>

    <div className="absolute top-[-20px] right-[20px] z-20">
      <div>{icon}</div>
    </div>
    {buttonLink && (
      <a href={buttonLink} target="_blank" rel="noreferrer">
        <PrimaryButton
          className={
            'absolute bottom-10 left-10 mt-10 px-5 py-2 flex items-center justify-center gap-2'
          }
        >
          <svg
            width="13"
            height="14"
            viewBox="0 0 13 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.70839 12.9935C1.1568 12.9935 0.789062 12.5792 0.789062 11.9314V1.85297C0.789062 1.20518 1.1568 0.790894 1.70839 0.790894C2.00718 0.790894 2.25233 0.896348 2.56644 1.06959L11.0473 5.89791C11.6602 6.2444 11.8823 6.49297 11.8823 6.89219C11.8823 7.29142 11.6602 7.53999 11.0473 7.88648L2.56644 12.7148C2.25233 12.888 2.00718 12.9935 1.70839 12.9935Z"
              fill="white"
              stroke="white"
              strokeWidth="1.58182"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>

          <span className="text-white text-sm  lg:leading-6 uppercase tracking-wider">
            ВИДЕО КАК РАБОТАЕТ
          </span>
        </PrimaryButton>
      </a>
    )}
  </div>
)

const HowWorksSectionNew = () => {
  return (
    <div className="bg-[#02070D] px-5 lg:px-0">
      <div className="pt-[100px] lg:pt-[150px] flex flex-col lg:items-center">
        <div className="max-w-[1200px] mx-auto mb-20">
          <h1 className="text-[#FBFBFC] text-4xl md:text-[60px] font-medium leading-tight mb-12 lg:text-center">
            <span className="text-[#52575D]">
              Прайс
              <br className=" lg:hidden" /> Ниндзя —
            </span>
            <br className=" lg:hidden" /> это три сервиса
          </h1>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 justify-start  w-full">
            <ServiceCard
              icon={<img src="/assets/repricer.png" width={100} height={100} />}
              title="Репрайсер"
              description={
                <>
                  Автоматически обновляет цены
                  <br className="hidden lg:block" /> по заданным правилам
                  <br className="hidden lg:block" /> и увеличивает маржу
                </>
              }
              color={'bg-[#D172F9]'}
              buttonLink={
                'https://rutube.ru/video/a77fb367c6e9625b1c51236b4d424f66/'
              }
            />
            <ServiceCard
              icon={
                <img src="/assets/monitoring.png" width={100} height={100} />
              }
              title="Мониторинг цен"
              description={
                <>
                  Следите за ценами конкурентов
                  <br className="hidden lg:block" /> и соблюдением РРЦ.
                  <br className="hidden lg:block" /> Оповещения, история
                  изменений и полный контроль
                </>
              }
              color={'bg-[#7A85FF]'}
              buttonLink={
                'https://rutube.ru/video/989529a5572de35c537490cac6f46fef'
              }
            />
            <ServiceCard
              icon={
                <img
                  src="/assets/search-monitoring.png"
                  width={100}
                  height={100}
                />
              }
              title="Мониторинг поисковых фраз"
              description={
                <>
                  Узнайте, по каким запросам
                  <br className="hidden lg:block" /> вас находят — и на каких
                  позициях вы в выдаче
                </>
              }
              color={'bg-[#FF4362]'}
            />
          </div>
        </div>

        <RepricerSection />

        <MonitoringSection />

        <SearchMonitoringSection />
      </div>
    </div>
  )
}

export default HowWorksSectionNew
